<template>
    <div class="contact-form-area">
        <div class="contact-info text-center">
            <h2>Send your query</h2>
            <p>We are always ready to listen you first</p>
        </div>
              <form name="rform" class="add" id="rform" method="post" v-on:submit="checkForm">
                <p class="errors" v-if="errors.status">{{ errors.message }}</p>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            placeholder="Your Name"
                            v-model="contacts.name"
                            class="form-control"
                            title="Please enter your name"
                            name="name"
                          />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            placeholder="Your Email"
                            v-model="contacts.email"
                            class="form-control"
                            title="Please enter a valid email"
                            name="email"
                          />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            placeholder="Your Number"
                            v-model="contacts.contact_number"
                            class="form-control"
                            title="Please enter a valid Mobile Number"
                            name="contact_number"
                          />
                        </div>
                    </div>    
                    <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            placeholder="Subject"
                            v-model="contacts.subject"
                            class="form-control"
                            title="Please enter a valid Subject"
                            name="subject"
                          />
                        </div>
                    </div>
                </div> 
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">     
                          <textarea
                            placeholder="Message"
                            class="form-control"
                            title="Please enter a Message"
                            name="message"
                            v-model="contacts.message"
                            rows="7"
                            cols="60"
                          ></textarea>
                        </div>
                    </div>
                </div> 
                <div class="col-md-12 text-center">     
                  <div class="form-group">
                    <button
                      type="button"
                      id="button1"
                      class="btn btn-dark"
                      v-on:click="checkForm()"
                    >
                      Submit Now
                    </button>
                  </div>
                </div>
                <div class="col-md-12 text-center">
                  <div class="form-group">
                    <p class="success-msg" v-if="this.contacts.dataContact">
                      Contact has Been Submitted Successfully.
                    </p>
                  </div>  
                </div>  
              </form>
              <p>&nbsp;</p>
              <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15551.46133568209!2d77.613026!3d12.9804639!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb1ddbae4c2775ced!2sMANIPAL%20NATURAL%20EXTRACTS%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1621668467680!5m2!1sen!2sin"
              width="100%" height="290" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
    </div>  
</template>

 

<script>
// import axios from "axios";

export default {
  name: "Add",
  data() {
    return {
      contacts: {
        name: "",
        email: "",
        contact_number: "",
        subject: "",
        message: "",
        dataContact: false,
        regex: /^[789]\d{9}$/,
      },
      errors: {
        status: false,
        message: "",
      },
    };
  },

  methods: {
    checkForm() {
      const emailRegex =
        /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
      if (this.contacts.name === "") {
        this.errors.status = true;
        this.errors.message = "Please enter name.";
      } else if (this.contacts.name.length < 3) {
        this.errors.status = true;
        this.errors.message = "Please enter a valid name.";
      } else if (this.contacts.email === "") {
        this.errors.status = true;
        this.errors.message = "Please enter email.";
      } else if (!emailRegex.test(this.contacts.email)) {
        this.errors.status = true;
        this.errors.message = "Please enter a valid email.";
      } else if (this.contacts.contact_number === "") {
        this.errors.status = true;
        this.errors.message = "Please enter contact number.";
      } else if (!this.contacts.regex.test(this.contacts.contact_number)) {
        this.errors.status = true;
        this.errors.message = "Please enter a valid contact number.";
      } else if (this.contacts.subject === "") {
        this.errors.status = true;
        this.errors.message = "Please enter subject.";
      } else if (this.contacts.message === "") {
        this.errors.status = true;
        this.errors.message = "Please enter message.";
      } else {
        console.warn("Contact has Been Submitted Successfully.");
        this.errors.message = "";
        this.addContact();
      }
    },

    async addContact() {
      const res = await fetch(`${this.apiURL}api/mail/send`, {
        method: "POST",
        body: JSON.stringify({
          to: 'info@manipalnatural.com',
          subject: this.contacts.subject,
          message: this.contacts.message,
          name: this.contacts.name,
          email: this.contacts.email,
          phone: this.contacts.contact_number,
          account:"manipalnatural"
          // status: "1",
        }),
        ...this.reqOptions,
      });
      this.contacts.dataContact = true;
      (this.contacts.dataContact = true),
      (this.contacts.name = ""),
      (this.contacts.email = ""),
      (this.contacts.contact_number = ""),
      (this.contacts.subject = "");
      this.contacts.message = "";
      console.warn(res);
      if (res.status == 201) {
        this.contacts.dataContact = true,
        this.contacts.name = "",
        this.contacts.email = "",
        this.contacts.contact_number = "",
        this.contacts.subject = "";
        this.contacts.message = "";
      }
    },
  },
};
</script>

 

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  line-height: 1.42857143;
  color: #333;
}
.contact-pg-section form {
  overflow: hidden;
  margin: 0 -15px;
}
.add {
  margin-top: -30px;
}
p.errors {
  text-align: center;
  padding: 0.5rem 0;
  color: darkred;
  font-weight: 700;
}
.success-msg {
  color: green;
}
.theme-btn-s2 {
  margin-top: 15px;
}
</style>